// extracted by mini-css-extract-plugin
export default {"inlineErrorIndication":"TLWrjM","iconErrorMessage":"GIPQqH","txtErrMsg":"JNgJbf"};